'use client'

import { createContext, use } from 'react'

/** How tightly a table packs its rows, from Comfortable (multi-line cells) to Dense. */
export const ROW_DENSITIES = [
  { label: 'Comfortable', value: 'comfortable' },
  { label: 'Compact', value: 'compact' },
  { label: 'Condensed', value: 'condensed' },
  { label: 'Dense', value: 'dense' },
] as const

export type RowDensity = (typeof ROW_DENSITIES)[number]['value']

/** A table that never chose a density shows Comfortable rows. */
export const DEFAULT_ROW_DENSITY: RowDensity = 'comfortable'

const RowDensityContext = createContext<RowDensity>(DEFAULT_ROW_DENSITY)

/** Gives one table's cells its row density; cells outside it render Comfortable. */
export const RowDensityProvider = RowDensityContext

export const useRowDensity = () => use(RowDensityContext)

/** Condensed and Dense rows keep the header to one line, so it doesn't take back the rows they gain. */
export const hasOneLineHeader = (density: RowDensity) =>
  density === 'condensed' || density === 'dense'
